import "./AddCard.css";
import AddIcon from "@mui/icons-material/Add";

export default function AddCard({ setShowNewEventForm }) {
  return (
    <div
      className="card add event-card event-card--add"
      onClick={() => setShowNewEventForm({ isShown: true })}
    >
      <AddIcon sx={{ fontSize: 82, color: "#4567E6" }} />
    </div>
  );
}
